import { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import { PageLoader, useMinLoading } from "@/components/Preloader";
import { V2 } from "@/components/home2/tokens";
import { Hero30 } from "@/components/home2/hero3/Hero30";
import { OriginalsMagazine } from "@/components/home2/OriginalsMagazine";
import { MarketIntelligenceField } from "@/components/home2/MarketIntelligenceField";
import { SignalPortals } from "@/components/home2/SignalPortals";
import { RegulationField } from "@/components/home2/RegulationField";
import { ResearchStudio } from "@/components/home2/ResearchStudio";
import { PremiumVault } from "@/components/home2/PremiumVault";
import { DailyBriefFinale } from "@/components/home2/DailyBriefFinale";

/* Homepage V2 — Figma production masters 200:3 (1440) / 204:3 (1280) /
   205:3 (768) / 206:3 (390); Hero 3.0 authority 195:3. Section order per
   master: Hero 3.0 → Originals → Market Intelligence → Explore the Onchain
   Economy → Regulation → Research → Premium → Daily Brief. Real data
   everywhere; production "/" untouched until Founder cutover approval.
   Previous V2 sections (PulseBar/Sponsor/FrontLayer/Newsstream/
   IntelligenceCurrent/SectorCurrent) retired from this route per the new
   masters — files preserved. */
export default function HomeV2() {
  const { data, isLoading } = useQuery({
    queryKey: ["homepage"],
    queryFn: async () => (await api.get("/homepage")).data,
    staleTime: 60_000,
  });
  const showLoader = useMinLoading(isLoading);

  useEffect(() => {
    const m = document.createElement("meta");
    m.name = "robots";
    m.content = "noindex,nofollow";
    document.head.appendChild(m);
    return () => { document.head.removeChild(m); };
  }, []);

  if (showLoader) return <PageLoader />;
  if (!data) return null;

  return (
    <div data-testid="home-v2-page" style={{ background: V2.bg }}>
      <div className="max-w-[1400px] mx-auto px-[16px] md:px-[24px] xl:px-[40px]">
        <Hero30 data={data} />
        <OriginalsMagazine data={data} />
        {/* Gate 3.2 Final Market Intelligence (approved flagship — terrain locked) */}
        <MarketIntelligenceField />
        <SignalPortals />
        <RegulationField data={data} />
        <ResearchStudio data={data} />
        <PremiumVault data={data} />
        <DailyBriefFinale />
        <div className="h-[60px]" />
      </div>
    </div>
  );
}
